import React from 'react';
import styled from 'styled-components';
import { FiCode, FiLayers, FiTool, FiGitBranch } from 'react-icons/fi';
import Reveal from './ui/Reveal';
import SpotlightCard from './ui/SpotlightCard';
import { getTechIcon } from './ui/techIcon';
import { useI18n } from '../context/LanguageContext';

const Section = styled.section`
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 6rem 2rem;
  @media (max-width: 768px) { padding: 4.5rem 1.25rem; }
`;

const Head = styled.div`
  text-align: center; margin-bottom: 3rem;
  h2 { font-size: clamp(2rem, 4.5vw, 2.9rem); margin-bottom: 1rem; }
  p { color: var(--text-muted); max-width: 560px; margin: 0 auto; }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  @media (max-width: 760px) { grid-template-columns: 1fr; }
`;

const Group = styled(SpotlightCard)`
  padding: 1.75rem;
  .top { display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1.25rem; }
  .icon {
    display: grid; place-items: center; width: 42px; height: 42px; border-radius: 12px;
    background: var(--bg-alt); border: 1px solid var(--border); color: var(--primary-light); font-size: 1.15rem;
  }
  h3 { font-size: 1.15rem; }
`;

const Chips = styled.div`
  display: flex; flex-wrap: wrap; gap: 0.6rem;
`;

const Chip = styled.div`
  display: inline-flex; align-items: center; gap: 0.5rem;
  padding: 0.5rem 0.9rem; border-radius: 999px;
  border: 1px solid var(--border); background: var(--bg-alt);
  font-size: 0.9rem; font-weight: 500; color: var(--text);
  transition: border-color 0.2s ease, transform 0.2s ease, background 0.2s ease;
  svg { font-size: 1.05rem; color: var(--primary-light); transition: color 0.2s ease; }
  &:hover { border-color: var(--primary-light); background: var(--surface-hover); transform: translateY(-2px); }
  &:hover svg { color: var(--secondary); }
`;

const groupIcon = {
  code: <FiCode />,
  layers: <FiLayers />,
  tool: <FiTool />,
  flow: <FiGitBranch />,
};

const Skills = () => {
  const { t, data } = useI18n();
  const { skillGroups } = data;

  return (
  <Section id="skills">
    <Reveal>
      <Head>
        <span className="eyebrow">{t.skills.eyebrow}</span>
        <h2>{t.skills.h2a}<span className="gradient-text">{t.skills.h2b}</span></h2>
        <p>{t.skills.sub}</p>
      </Head>
    </Reveal>

    <Grid>
      {skillGroups.map((group, i) => (
        <Reveal key={group.title} delay={i * 0.06}>
          <Group>
            <div className="top">
              <span className="icon">{groupIcon[group.icon]}</span>
              <h3>{group.title}</h3>
            </div>
            <Chips>
              {group.items.map((item) => (
                <Chip key={item}>{getTechIcon(item)}{item}</Chip>
              ))}
            </Chips>
          </Group>
        </Reveal>
      ))}
    </Grid>
  </Section>
  );
};

export default Skills;
